<template>
  <div class="card p-4">
    <div class="col-12 d-md-flex justify-content-lg-between mb-3 clickable" @click.prevent="toggle">
      <h4><span class="badge badge-danger"><b>{{ showing ? "--":"+"}}</b></span> Cupons de desconto</h4>
    </div>

    <div class="collapse show" id="collapse-cupons">
      <div class="col-12 mb-3">
        <form class="row" @submit.prevent="">
          <div class="col-12 col-md-3 mb-3">
            <label>Tipo de Cupom</label>
            <select
              v-model="coupom.type"
              class="form-control form-control-sm custom-select custom-select-sm"
              :class="{
                'is-invalid': coupom.errors.has('type')
              }"
            >
              <option value="C">Cupom</option>
              <option value="L">Link</option>
            </select>
            <has-error :form="coupom" field="type" />
          </div>

          <div class="col-12 col-md-6 mb-3">
            <label>Cupom</label>
            <div class="input-group input-group-sm">
              <input
                style="text-transform: uppercase"
                v-model="coupom.content"
                class="form-control form-control-sm"
                :class="{
                  'is-invalid': coupom.errors.has('content')
                }"
              />
              <span class="input-group-append">
                <button class="input-group-text" @click="generateCoupon">
                  Gerar Aleatóriamente
                </button>
              </span>
            </div>
            <has-error :form="coupom" field="content" />
          </div>

          <div class="col-12 col-md-3 mb-3">
            <label>Qtd de cupons</label>
            <input
              type="number"
              v-model="coupom.quantity"
              min="0"
              class="form-control form-control-sm"
              :class="{
                'is-invalid': coupom.errors.has('quantity')
              }"
            />
            <has-error :form="coupom" field="quantity" />
          </div>

          <div class="col-12 col-md-3 mb-3">
            <label>Tipo de Desconto</label>
            <select
              v-model="coupom.discount_type"
              class="form-control form-control-sm custom-select custom-select-sm"
              :class="{
                'is-invalid': coupom.errors.has('discount_type')
              }"
            >
              <option value="P">Percentual</option>
              <option value="V">Valor Fixo</option>
            </select>
            <has-error :form="coupom" field="discount_type" />
          </div>

          <div class="col-12 col-md-3 mb-3">
            <label>Valor</label>
            <input
              type="number"
              v-model="coupom.discount_value"
              min="0"
              class="form-control form-control-sm"
              :class="{
                'is-invalid': coupom.errors.has('discount_value')
              }"
            />
            <has-error :form="coupom" field="discount_value" />
          </div>

          <div class="col-12 col-md-6 mb-3">
            <label>Validade do Cupon</label>
            <!-- <div class="input-group input-group-sm">
              <date-time-picker
                id="dtpStartDate"
                label="Data e Hora Inical"
                v-model="coupom.start_date"
                minute-interval="10"
                format="YYYY-MM-DD HH:mm"
              />

              <date-time-picker
                id="dtpEndDate"
                label="Data e Hora Final"
                v-model="coupom.end_date"
                minute-interval="10"
                format="YYYY-MM-DD HH:mm"
              />
            </div> -->
            <!-- {{coupom.start_date}} -->
            <div class="input-group input-group-sm">
              <input
                v-model="coupom.start_date"
                class="form-control form-control-sm"
                :class="{
                  'is-invalid': coupom.errors.has('start_date')
                }"
                type="date"
              />
              <span class="input-group-append">
                <span class="input-group-text">
                  Até
                </span>
              </span>
              <input
                v-model="coupom.finish_date"
                class="form-control form-control-sm"
                :class="{
                  'is-invalid': coupom.errors.has('finish_date')
                }"
                type="date"
              />
            </div>
            <has-error :form="coupom" field="start_date" />
            <has-error :form="coupom" field="finish_date" />
          </div>

          <div class="col-12 text-right">
            <button class="btn btn-sm btn-success" @click="save">Salvar Cupom</button>
          </div>
        </form>
      </div>

      <div class="col-12">
        <table class="table table-responsive-md table-sm">
          <thead>
            <tr>
              <th>Tipo</th>
              <th>Cupom</th>
              <th>Tipo de Desconto</th>
              <th>Valor</th>
              <th>Usados</th>
              <th>Validade</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="cupom in cupons.data" :key="cupom.id">
              <td v-if="cupom.type === 'C'">Cupom</td>
              <td v-else>Link</td>

              <td>
                {{ cupom.content }}
                <button v-if="cupom.link" class="btn btn-sm btn-dark" @click="copyLink(cupom.link)">Copiar Link</button>
              </td>

              <td v-if="cupom.discount_type === 'P'">Porcentagem (%)</td>
              <td v-else>Valor (R$)</td>

              <td>{{ cupom.discount_value }}</td>

              <td>{{ cupom.usage }} <small>de {{ cupom.quantity ? cupom.quantity:'&infin;' }}</small></td>
              <td>{{ cupom.start_date }} até {{ cupom.finish_date ? cupom.finish_date:'&infin;' }}</td>

              <td>
                <button class="btn btn-sm btn-danger" @click="del( cupom.id )"><i class="fa fa-trash"></i></button>
                <button class="btn btn-sm btn-primary" @click="edit( cupom )"><i class="fa fa-edit"></i></button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
import Swal from 'sweetalert2'
import { Form, HasError } from 'vform'

export default {
  props: {
    course: {
      required: true
    }
  },
  watch: {
    course: {
      immediate: true,
      handler ( val, old ) {
        if ( val != undefined && val != old ) {
          this.load()
        }
      }
    }
  },
  data () {
    return {
      url: undefined,
      showing: true,
      cupons: [],
      coupom: new Form({
        id: undefined,
        course_id: undefined,
        type: undefined,
        content: undefined,
        quantity: undefined,
        usage: 0,
        discount_type: undefined,
        discount_value: undefined,
        start_date: undefined,
        finish_date: undefined,
        is_actived: true,
      })
    }
  },
  methods: {
    save: function () {
      this.coupom.course_id = this.course
      this.coupom.post('/teacher/course/coupon')
        .then( res => {
          Swal.fire({
            icon: 'success',
            text: 'Informações atualizadas',
            title: 'Sucesso'
          })
          this.load()
        })
        .catch( err => {
          console.error( err )
        })
        .then( () => {
          this.coupom.reset()
        })
    },
    del: function ( id ) {
      Axios.delete('/teacher/course/coupon', {
        data: {
          cupom: id
        }
      })
        .then( res => {
          Swal.fire({
            icon: 'success',
            text: 'Informações deletada',
            title: 'Sucesso'
          })
          this.load()
        })
        .catch( err => {
          console.error( err )
        })
    },
    edit: function ( item ) {
      this.coupom.fill( item )
    },
    load: function () {
      Axios.get(`/teacher/course/coupon?course=${ this.course }`)
        .then( res => {
          this.cupons = res.data
        })
        .catch( err => {
          console.error( err )
        })
    },
    generateCoupon: function () {
      let coupom = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 5);
      this.coupom.content = coupom.toUpperCase();
    },
    toggle: function () {
      this.showing = !this.showing
      $("#collapse-cupons").collapse('toggle')
    },
    copyLink: function (link) {
      let uri = this.url + link
      var el = document.createElement('textarea');
      el.value = uri;
      el.setAttribute('readonly', '');
      el.style = {position: 'absolute', left: '-9999px'};
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
    }
  },
  mounted() {
    this.url = window.location.protocol + '//' + window.location.host
  }
}
</script>
